import { FC } from 'react';
import { Switch } from 'components/UI/V3/Forms/Switch/Switch';
import styles from './OnlineBookingSection.module.scss';

interface OnlineBookingSectionProps {
    className?: string;
    checked: boolean;
    onChange: (checked: boolean) => void;
}

export const OnlineBookingSection: FC<OnlineBookingSectionProps> = ({ checked, onChange, className }) => {
    return (
        <div className={`${styles.switchSection} ${className || ''}`}>
            <Switch
                label="Online Booking"
                inlineLabel="Bookable online"
                checked={checked}
                onChange={onChange}
            />
        </div>
    );
};
